module.exports = __webpack_public_path__ + "static/media/have-a-heart.02d21291.png";